import { defineComponent, ref, onMounted,inject } from "/Scripts/vue.esm-browser.js";
import HeaderNavBottom from "./HeaderNavBottom.js";
import HeaderNavTop from "./HeaderNavTop.js";
import HeaderLogo from "./HeaderLogo.js";
import Announce from "./Announce.js";

const html = String.raw;

export default defineComponent({
    name: "Header",
    props: {
        bbcSn: {
            type: String,
            required: false,
        },
    },
    components: {
        Announce,
        HeaderNavBottom,
        HeaderNavTop,
        HeaderLogo
    },
    setup(props, { emit }) {
        const web = inject("web");
        //const getWebSite = () => {
        //    const hostname = window.location.hostname;

        //    if (hostname.startsWith("b2b.")) {
        //        return "b2b";
        //    } else if (hostname.includes("bbctour")) {
        //        return "bbc";
        //    } else if (hostname.startsWith("b2e.")) {
        //        return "b2e";
        //    }
        //    //localhost
        //    return props.webSite;
        //};

        //const webSite = ref(getWebSite());
        const isMenuOpen = ref(false);

        const toggleMenu = () => {
            isMenuOpen.value = !isMenuOpen.value;
            document.body.classList.toggle("menu-on");
        };

        const handleScroll = () => {
            const pageArrow = document.querySelector(".page-arrow");
            if (!pageArrow) return;

            if (window.scrollY > window.innerHeight) {
                pageArrow.classList.remove("down");
                pageArrow.classList.add("up");

                // 回到頂部
                pageArrow.onclick = () => {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                };
            } else {
                pageArrow.classList.remove("up");
                pageArrow.classList.add("down");

                pageArrow.onclick = () => {
                    window.scrollTo({
                        top: window.scrollY + window.innerHeight,
                        behavior: "smooth",
                    });
                };
            }
        };

        onMounted(() => {
            window.addEventListener("scroll", handleScroll);
        });

        return {
            isMenuOpen,
            toggleMenu,
            web
        };
    },
    template: html`
    <header>
      <div class="header-wrapper header-b2c">
          <div class="header-main">
            <div class="header-main-wrapper">
              <div id="nav_sw" class="nav-sw" @click="toggleMenu">
                <div class="nav-sw-in">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <header-logo :web-site="web" :bbc-sn="bbcSn"></header-logo>
              <div class="header-nav">
                <header-nav-top :web-site="web"></header-nav-top>
                <header-nav-bottom :web-site="web"></header-nav-bottom>
              </div>
            </div>
          </div>
          <announce />
        </div>
    </header>
  `,
});
